import { Field, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { Button } from 'components/Feature/Custom/Button';
import { ComponentProps } from 'lib/component-props';
import { useEffect, useState } from 'react';
import { A11y, FreeMode, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

type CareerJoinUsProps = ComponentProps & {
  fields: {
    title: Field<string>;
    description: Field<string>;
    childItems: any;
  };
  locale: string;
  lang: string;
};

const CareerJoinUs = (props: CareerJoinUsProps): JSX.Element => {
  const [mountend, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  });
  if (!mountend) return null as any;
  return (
    <div className="w-100 my-24 py-24 h-full">
      <div className={`flex flex-col-reverse ${props?.locale == props?.lang? "lg:flex-row-reverse": "lg:flex-row"} text-theme-color min-h-full`}>
        <Swiper
          slidesPerView={2}
          spaceBetween={10}
          freeMode={true}
          pagination={true}
          centeredSlides={true}
          modules={[FreeMode, Pagination, A11y]}
          a11y={{
            enabled: true,
            paginationBulletMessage: "Go to slide {{index}}",
          }}
          breakpoints={{
            1024: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            1280: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          }}
          className={`career-swiper move-pagination bg-career-gredient-theme-color w-full !overflow-visible min-h-full relative lg:w-1/2 animate-right
          [&>*:nth-child(2)]:!left-0 ${props?.locale == props?.lang? "lg:[&>*:nth-child(2)]:!-left-[50%]": "lg:[&>*:nth-child(2)]:!left-[50%]"}`}
        >
          {props?.fields?.childItems?.map((item: any, index: any) => {
            return (
              <SwiperSlide
                className="bg-card-theme-color h-10 cursor-grab focus:cursor-move lg:min-w-[40%] lg:min-h-[24rem]"
                key={index}
              >
                <div className={`text-start flex flex-col p-4 lg:p-5 2xl:px-10 2xl:py-12 h-full justify-between w-full ${props?.locale == props?.lang? "rtl": ""}`}>
                  <h3 className="text-[30px] md:text-4xl">{item?.fields?.Title?.value}</h3>
                  <p className="py-14">{item?.fields?.Description?.value}</p>
                  {item?.fields?.['Button Enabled']?.value && (
                    <Button
                      classNames="self-end border-brand-100 button-hover-theme-color"
                      redirect={item?.fields?.ButtonUrl?.value?.href}
                      text={item?.fields?.ButtonText?.value}
                      target={item?.fields?.ButtonUrl?.value?.target}
                      linktype={item?.fields?.ButtonUrl?.value?.linktype}
                    />
                  )}
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div className={`flex flex-col p-4 w-full text-theme-color animate-left text-start bg-theme-color z-50 lg:w-[60%] lg:justify-center ${props?.locale == props?.lang? "rtl": ""}`}>
          <h1 className="text-3brand md:text-2brand xl:text-1brand font-medium lg:leading-brand">{props?.fields?.title?.value}</h1>
          <p className="pt-6 lg:pt-0 w-full xl:w-2/4 md:text-4brand">{props?.fields?.description?.value}</p>
        </div>
      </div>
    </div>
  );
};

export default withDatasourceCheck()<CareerJoinUsProps>(CareerJoinUs);
